angular.module('cian.advancedBrowser')
.directive('advancedBrowser', [() => {
  return {
    scope: true,
    template: require('../../templates/advanced-browser.html'),
    restrict: 'E',
    bindToController: {
      source: '=',
      ads: '=?',
    },
    controllerAs: 'advancedBrowser',
    controller: [
      '$element',
      '$uibModal',
      '$scope',
      '$timeout',
      'FilterBackup',
      'AnalyticsService',
      function controller($element, $uibModal, $scope, $timeout, FilterBackup, AnalyticsService) {
      const ctrl = this;

      $scope.$watch(
        () => ctrl.source,
        newVal => ($scope.source = newVal)
      );

      angular.element($element).on('click', () => {
        if (!ctrl.isPopupOpen) {
          ctrl.isPopupOpen = true;

          FilterBackup.backup();
          AnalyticsService.trackCA('Listing', 'popup_more_param_open');

          $uibModal.open({
            scope: $scope.$new(),
            template: require('../../templates/advanced-browser.popup.html'),
            animation: true,
            windowClass: 'serp-modal advanced-browser-modal',
            controller: 'AdvancedBrowserPopupCtrl',
            controllerAs: 'advancedPopup',
            resolve: {
              ads: () => ctrl.ads,
            },
          }).result
            .then(null, FilterBackup.restore)
            .finally(() => {
            ctrl.isPopupOpen = false;
          });
        }
      });
    }],
  };
}]);



// WEBPACK FOOTER //
// ./src/components/advanced-browser/src/scripts/cian.advanced-browser.dir.js